import React from 'react'
import { NavBar } from '../components'

export const AdoptionNewPage = () => {
    return (
    <>
        <NavBar title='Nueva adopción' />

        <main>
            
        </main>
    
    </>
    )
}
